import {
  ScrollView,
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { getLoginData } from "../../../utility/AppStoreData";
import { AppImages } from "../../../utility/AppImages";
import DateTimePickerModal from "../WebScreens/Common/DateTimePickerModal";
import dayjs from "dayjs";
import { StackActions } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppScreens } from "../../Utility/AppScreens";
import * as ImagePicker from "expo-image-picker";
import { toast } from "react-toastify";
import { enumAddEditPublicPrivateScreen } from "./CreatePrivateEventScreen";
import CompetitorsModal from "../WebScreens/CreateEvents/CompetitorsModal";
import { BeltImages } from "../../../Api/configs";
import { MobileDeviceNavigationHeader } from "../WebScreens/Common/MobileDeviceNavigationHeader";
import { handleApiError } from "../../../services/errorHandler";
import {
  fetchPaymentBeltExchange,
  fetchUserBalance,
} from "../../../services/profileAPI";
import { fetchGenreGames, uploadToS3 } from "../../../services/authAPI";
import CornfirmPurchaseBeltModal from "../WebScreens/BeltScreens/CornfirmPurchaseBeltModal";
import StreamingAccountModal from "../WebScreens/CreateEvents/StreamingAccountModal";
import ConnetedPopup from "../WebScreens/CreateEvents/ConnetedPopup";
import { useTooltips } from "../../../context/WalkthroughContext";
import NoBalancePopup from "../WebScreens/CreateEvents/NoBalancePopup";
import PublicEventCreateComponent from "../../../Components/create-event-components/PublicEventCreateComponent";
import { fetchEventDetails, updateEvent } from "../../../services/eventsAPI";
import { storeUserActivity, ACTIVITY_TYPES } from "../../../services/activityService";
import Header from "../WebScreens/Common/Header";
import ChallengeModeComponent from "../../../Components/create-event-components/ChallengeModeComponent";
import EventNameAndGameComponent from "../../../Components/create-event-components/EventNameAndGameComponent";
import Separator from "../../../Components/Separator";
import DeviceAndGameIdComponent from "../../../Components/create-event-components/DeviceAndGameIdComponent";
import DescriptionAndImageComponent from "../../../Components/create-event-components/DescriptionAndImageComponent";
import SchedulingEventComponent from "../../../Components/create-event-components/SchedulingEventComponent";
import SelectBeltsComponent from "../../../Components/create-event-components/SelectBeltsComponent";
import InefficientBeltsPopup from "../WebScreens/CreateEvents/InefficientBeltsPopup";
import BeltPurchaseSuccessModal from "../WebScreens/BeltScreens/BeltPurchaseSuccessModal";
import { ShowLoader } from "../../../common/ShowLoader";
import ChangesReadyToSendModal from "./UpdateEventsPopup/ChangesReadyToSendModal";

const exchangeRates = {
  bronze: 550,
  silver: 5500,
  gold: 55000,
  platinum: 550000,
};

const sellRates = {
  bronze: 5,
  silver: 50,
  gold: 500,
  platinum: 5000,
};

export default function UpdatePublicEventScreen({ navigation, route }) {
  // this is for private event
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [organiserId, setOrganiserId] = useState("");

  const [dateTimeInput, setDateTimeInput] = useState("");
  const [eventName, setEventName] = useState("");
  const [selectStake, setSelectStake] = useState([""]);
  const [amount, setAmount] = useState([]);
  // const [minAttendees, setMinAttendees] = useState("");
  const [description, setDescription] = useState("");
  const [userData, setUserData] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectDate, setSelectDate] = useState("");
  const [selectTime, setSelectTime] = useState("");
  const [duration, setDuration] = useState("");
  const [challengeMode, setChallengeMode] = useState("1 VS 1");
  const [playType, setPlayType] = useState("Competitive");
  const [gameType, setGameType] = useState("Fortnite");
  const [eventType, setEventType] = useState("");
  const [selectGame, setSelectGame] = useState("");
  // const [ticketPrice, setTicketPrice] = useState("");
  const [gamerID, setGamerID] = useState("");
  const [device, setDevice] = useState("");
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [
    tooltipForCompeteWithoutStreamingVisible,
    setTooltipForCompeteWithoutStreamingVisible,
  ] = useState(false);
  const [tooltipForGift, setTooltipForGift] = useState(false);
  const [refreshAPICall, setRefreshAPICall] = useState(false);
  const [competitorModel, setCompetitorModel] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const [apiData, setApiData] = useState({});
  const [cornfirmPurchaseBeltModal, setCornfirmPurchaseBeltModal] =
    useState(false);
  const [beltPurchaseSuccessModal, setBeltPurchaseSuccessModal] =
    useState(false);
  // Switchies

  const [youTubeSwitch, setYouTubeSwitch] = useState(false);
  const [streamingSwitch, setStreamingSwitch] = useState(false);
  const [twitchSwitch, setTwitchSwitch] = useState(false);

  const [chatSwitch, setChatSwitch] = useState(false);
  const [competitorSwitch, setCompetitorSwitch] = useState(false);
  const [allOrNothingSwitch, setAllOrNothingSwitch] = useState(false);

  const [showLoader, setShowLoader] = useState(false);
  const [userBalanceData, setUserBalanceData] = useState(null);
  // const [ticketSystem, setTicketSystem] = useState("Token");
  const [balancePopup, setBalancePopup] = useState(false);
  const [publicVotingEnabled, setPublicVotingEnabled] = useState(false);
  const [showYoutubePopup, setShowYoutubePopup] = useState(false);
  const [showTwitchPopup, setShowTwitchPopup] = useState(false);
  const [connectedPopup, setConnectedPopup] = useState(false);
  const [beltDetailTooltip, setBeltDetailTooltip] = useState(false);
  const [inefficientBeltsPopup, setInefficientBeltsPopup] = useState(false);
  const [previousEventDetails, setPreviousEventDetails] = useState<any>(null);
  const [actionStatus, setActionStatus] = useState<boolean | null>(null); // Store actionStatus
  const [showChangesReadyModal, setShowChangesReadyModal] = useState(false);

  // State to fix race condition between balance and event details APIs
  const [isBalanceLoaded, setIsBalanceLoaded] = useState(false);
  const [eventStakes, setEventStakes] = useState<any[]>([]);
  const [eventAcceptStatus, setEventAcceptStatus] = useState<boolean>(false);

  const [arrDetermineStakes, setArrDetermineStakes] = useState([
    {
      id: 0,
      value: 0,
      image: AppImages.icCoinBelt,
      isAvailableAmountSelected: 1,
      title: "Coin",
      isSelected: true,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 58,
    },
    {
      id: 1,
      value: 0,
      image: AppImages.icBronzeBelt,
      isAvailableAmountSelected: 1,
      title: "Bronze",
      isSelected: true,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 2,
      value: 0,
      image: AppImages.icSilverBelt,
      isAvailableAmountSelected: 0,
      title: "Silver",
      isSelected: true,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 3,
      value: 0,
      image: AppImages.icGoldBelt,
      isAvailableAmountSelected: 0,
      title: "Gold",
      isSelected: false,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 4,
      value: 0,
      name: "Platinum",
      image: AppImages.icPlatinumBelt,
      isAvailableAmountSelected: 0,
      title: "Platinum",
      isSelected: false,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
  ]);

  const [numberOfBelts, setNumberOfBelts] = useState("1");
  const checkUserBalanceAPI = async (accessTokenValue) => {
    setShowLoader(true);

    try {
      const data = await fetchUserBalance(accessTokenValue);
      setShowLoader(false);

      if (data) {
        setUserBalanceData(data.body);
        if (data?.body?.balance === 0) {
          setBalancePopup(true);
        }
        const belts = data.body?.belts;
        const coins = data.body?.coins || 0;

        const arr = [...arrDetermineStakes];

        // Only process belts if they exist
        if (belts) {
          arr.map((item) => {
            if (item.title === "Bronze") {
              item.value = Number(belts.bronze || 0);
              if (belts.bronze > 0) item.locked = false;
              item.purchaseLock = false;
            } else if (item.title === "Silver") {
              item.value = Number(belts.silver || 0);
              if (belts.silver > 0) item.locked = false;
            } else if (item.title === "Gold") {
              item.value = Number(belts.gold || 0);
              if (belts.gold > 0) item.locked = false;
            } else if (item.title === "Platinum") {
              item.value = Number(belts.platinum || 0);
              if (belts.platinum > 0) item.locked = false;
            } else if (item.title === "Coin") {
              item.value = Number(coins);
              if (coins > 0) item.locked = false;
            }
          });
        }
        setArrDetermineStakes(arr);
        setIsBalanceLoaded(true);
        setRefreshAPICall(false);
      } else {
        handleApiError(data.status, data.error);
        setRefreshAPICall(false);
      }
    } catch (error) {
      setShowLoader(false);
      setRefreshAPICall(false);
      toast.error(error.message);
    }
  };
  const paymentBeltExchangeAPI = async (accessTokenValue) => {
    setShowLoader(true);

    try {
      const response = await fetchPaymentBeltExchange(accessTokenValue);
      setShowLoader(false);
      if (response.statusCode === 200) {
        const arr = [...arrDetermineStakes];
        const stakeCurrentPrize = [];
        arr.map((item) => {
          if (item.title === "Bronze") {
            item.currentPrize = response.exchangeRates.bronze;
            item.sellPrice = response.sellRates.bronze;
          } else if (item.title === "Silver") {
            item.currentPrize = response.exchangeRates.silver;
            item.sellPrice = response.sellRates.silver;
          } else if (item.title === "Gold") {
            item.currentPrize = response.exchangeRates.gold;
            item.sellPrice = response.sellRates.gold;
          } else if (item.title === "Platinum") {
            item.currentPrize = response.exchangeRates.platinum;
            item.sellPrice = response.sellRates.platinum;
          }
          stakeCurrentPrize.push(item.currentPrize);
        });
        setStakeCurrentPrize(stakeCurrentPrize);
        setArrDetermineStakes(arr);
      } else {
        handleApiError(response.statusCode, response.error);
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };
  useEffect(() => {
    getLoginUserData((data) => {
      checkUserBalanceAPI(data.AccessToken);
      paymentBeltExchangeAPI(data.AccessToken);
    });
  }, [refreshAPICall]);

  useEffect(() => {
    if (route?.params?.token) {
      setCornfirmPurchaseBeltModal(true);
    }
  }, [route?.params]);

  async function getLoginUserData(success) {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);
      setAccessToken(data.AccessToken);
      success(data);
      setOrganiserId(data.username);
    }
  }

  const [fileContent, setFileContent] = useState(null);
  const [fileName, setFileName] = useState(null);

  const totalStakeBeltAmount = arrDetermineStakes
    .filter((item) => item.stakeBeltAmount > 0)
    .reduce((acc, item) => acc + item.stakeBeltAmount, 0);

  const updateSelectStakeAndAmount = () => {
    let selectedBelts = [];
    let totalAmount = [];

    arrDetermineStakes.forEach((belt) => {
      selectedBelts.push(belt.title);
      totalAmount.push(belt.stakeBeltAmount ? belt.stakeBeltAmount : 0);
    });
    setSelectStake(selectedBelts);
    setAmount(totalAmount);
  };

  useEffect(() => {
    updateSelectStakeAndAmount();
  }, [arrDetermineStakes]);

  function checkValidation() {
    if (eventName === "") {
      toast.error("Please enter event name");
    } else if (gamerID === "") {
      toast.error("Please enter Gamer ID");
    } else if (description === "") {
      toast.error("Please enter description");
    } else if (totalStakeBeltAmount === 0) {
      toast.error("You didn't have selected belts, Please first select belt");
    } else if (dateTimeInput === "") {
      toast.error("Please enter Date and Time");
    } else if (selectDate === "") {
      toast.error("Please select date");
    } else if (selectTime === "") {
      toast.error("Please select time");
    } else if (selectGame === "") {
      toast.error("Please select game");
    } else {
      callUpdateEventAPI();
    }
  }

  console.log(actionStatus);
  async function callUpdateEventAPI() {
    setShowLoader(true);

    // Prepare stakes data
    const stakeTypes = [];
    const stakeAmounts = [];
    arrDetermineStakes.forEach((belt) => {
      stakeTypes.push(belt.title);
      stakeAmounts.push(belt.stakeBeltAmount || 0);
    });

    const bodyParams = {
      accessToken,
      eventID: route.params.eventID,
      newDetails: {
        title: eventName,
        description: description,
        startDateTime: dateTimeInput,
        gameTitle: selectGame,
        gamerID: gamerID,
        device: device,
        eventImageUrl: fileContent,
        stakeType: stakeTypes,
        stakeAmount: stakeAmounts,
      },
    };

    try {
      if (actionStatus === false) {
        const response = await updateEvent(bodyParams);
        if (response.statusCode === 200 || response.statusCode === 201) {
          toast.success(response.body?.message || "Event updated successfully");

          // Track terms_modified activity (fire and forget)
          storeUserActivity(accessToken, route.params.eventID, ACTIVITY_TYPES.TERMS_MODIFIED, {
            updatedFields: Object.keys(bodyParams.newDetails),
          }).catch((err) => console.warn("Failed to track activity:", err));

          navigateToScreen(navigation, AppScreens.OnGoingEvents, {
            eventID: route.params.eventID,
          });
          await getEventDetails(route.params.eventID);
        } else if (response.statusCode === 400 || response.statusCode === 403) {
          toast.error(response.body.error);
        } else {
          handleApiError(
            response.statusCode,
            response.body?.error || "Update failed"
          );
        }
      } else {
        setShowChangesReadyModal(true);
      }
    } catch (error) {
      toast.error(
        error.message || "An error occurred while updating the event"
      );
    } finally {
      setShowLoader(false);
    }
  }

  const [games, setGames] = useState([]);
  const getGenreGames = async () => {
    try {
      const response = await fetchGenreGames();
      const responseBody =
        typeof response.body === "string"
          ? JSON.parse(response.body)
          : response.body;

      if (response.statusCode === 200) {
        const gamesList = responseBody.map((game) => game.title);

        setGames(gamesList);
        setShowLoader(false);
      } else {
        toast.error(responseBody.error);
      }
    } catch (error) {
      console.error("get games API Error:- ", error.message);
      toast.error(error.message);
    }
  };
  useEffect(() => {
    getGenreGames();
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const [openChild, setOpenChild] = useState(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleOutsideClick = () => {
    if (tooltipVisible) {
      setTooltipVisible(false);
    }
    if (tooltipForCompeteWithoutStreamingVisible) {
      setTooltipForCompeteWithoutStreamingVisible(false);
    }
    if (tooltipForGift) {
      setTooltipForGift(false);
    }
    if (showYoutubePopup) {
      setShowYoutubePopup(false);
    }
    if (showTwitchPopup) {
      setShowTwitchPopup(false);
    }
    if (connectedPopup) {
      setConnectedPopup(false);
    }
    if (beltsTooltip) {
      setBeltsTooltip(false);
    }
    if (beltDetailTooltip) {
      setBeltDetailTooltip(false);
    }
  };

  const handleSwitchToggle = (value) => {
    setYouTubeSwitch(value);
    // if (value) {
    //   setShowYoutubePopup(true);
    // }
  };
  const handleTwitchSwitchToggle = (value) => {
    setTwitchSwitch(value);
    // if (value) {
    //   setShowTwitchPopup(true);
    // }
  };
  const closePopup = () => {
    if (showYoutubePopup) {
      setShowYoutubePopup(false);
    }
    if (showTwitchPopup) {
      setShowTwitchPopup(false);
    }
  };

  useEffect(() => {
    if (connectedPopup) {
      closePopup();
    }
  }, [connectedPopup]);

  const scrollViewRef = useRef(null);
  const handleErrorResponse = (statusCode, errorMessage) => {
    if (statusCode === 400) {
      toast.error("Bad Request");
    } else if (statusCode > 400 && statusCode < 420) {
      toast.error("Unauthorized");
    } else if (statusCode >= 500) {
      toast.error("Internal Server Error");
    } else {
      toast.error(errorMessage);
    }
    navigateToScreen(navigation, AppScreens.Home);
  };

  useEffect(() => {
    if (route.params.eventID) {
      getEventDetails(route.params.eventID);
    }
  }, [route.params.eventID]);

  const getEventDetails = async (eventID) => {
    setShowLoader(true);
    const userData = await getLoginData();
    try {
      const data = await fetchEventDetails(eventID, userData.AccessToken);
      console.log("Event Data:", data);

      if (data) {
        setPreviousEventDetails(data);
        setActionStatus(data.acceptStatus ?? false);
        setEventName(data.eventTitle);
        setSelectGame(data.gameTitle);
        setDevice(data.device);
        setGamerID(data.gamerID);
        setDescription(data.description);
        setFileContent(data.eventImageUrl);
        setFileName(data.fileName);
        setSelectDate(dayjs(data.eventStartTime).format("DD/MM/YYYY"));
        setSelectTime(dayjs(data.eventStartTime).format("HH:mm"));
        setSelectStake(data.stakes.map((stake) => stake.type));
        setGameType(data.gameTitle);
        setYouTubeSwitch(data.organizerYoutubeStream);
        setTwitchSwitch(data.organizerTwitchStream);
        setStreamingSwitch(data.streamingPlatforms.organiser ? true : false);
        setChatSwitch(data.chat);
        setAllOrNothingSwitch(data.allOrNothing);
        setCompetitorSwitch(data.competitor);
        setDateTimeInput(data.eventStartTime);
        setEventType(data.eventType);
        setPublicVotingEnabled(data.publicVotingEnabled);
        // Store stakes separately - they will be merged with balance data in the dedicated useEffect
        setEventStakes(data.stakes || []);
        setEventAcceptStatus(data.acceptStatus ?? false);
      } else {
        handleErrorResponse(data.statusCode, data.body.error);
      }
    } catch (error) {
      toast.error("Error fetching event");
      navigateToScreen(navigation, AppScreens.Home);
    } finally {
      setShowLoader(false);
    }
  };

  // Effect to merge event stakes with balance data when both are ready
  // This fixes the race condition where getEventDetails and checkUserBalanceAPI
  // were both updating arrDetermineStakes independently
  useEffect(() => {
    if (isBalanceLoaded && eventStakes.length > 0) {
      const updatedStakes = arrDetermineStakes.map((item) => {
        const stakeItem = eventStakes.find((s) => s.type === item.title);
        // When challenge is accepted, divide by 2 to show only organizer's contribution
        // Total stakes = organizer + challenger, so organizer's contribution = total/2
        const stakeBeltAmount = stakeItem
          ? (eventAcceptStatus ? stakeItem.quantity / 2 : stakeItem.quantity)
          : 0;
        return {
          ...item,
          stakeBeltAmount: stakeBeltAmount,
        };
      });
      setArrDetermineStakes(updatedStakes);
    }
  }, [isBalanceLoaded, eventStakes, eventAcceptStatus]);

  const [normalizedSelectGame, setNormalizedSelectGame] = useState("");
  const [beltsTooltip, setBeltsTooltip] = useState(false);
  const [stakeTokenAmount, setStakeTokenAmount] = useState(0);
  const [stakeCurrencyAmount, setStakeCurrencyAmount] = useState(0);
  const [stakeCurrentPrize, setStakeCurrentPrize] = useState([]);

  useEffect(() => {
    const matchedGame = games.find(
      (game) => game.toLowerCase() === selectGame.toLowerCase()
    );

    if (matchedGame) {
      setNormalizedSelectGame(matchedGame);
    } else {
      setNormalizedSelectGame("");
    }
  }, [games, selectGame]);

  const formattedBeltString = useMemo(() => {
    const selectedBeltArray = arrDetermineStakes
      .filter((item) => item.stakeBeltAmount > 0)
      .map((item) => `${item.stakeBeltAmount} ${item.title}`);
    return selectedBeltArray.length > 0 ? selectedBeltArray.join(", ") : "0";
  }, [arrDetermineStakes]);

  const totalStakeTokenAmount = arrDetermineStakes.reduce((acc, item) => {
    const rate = exchangeRates[item.title.toLowerCase()] || 0;
    return acc + item.stakeBeltAmount * rate;
  }, 0);

  const totalStakeCurrencyAmount = arrDetermineStakes.reduce((acc, item) => {
    const sellRate = sellRates[item.title.toLowerCase()] || 0;
    return acc + item.stakeBeltAmount * sellRate;
  }, 0);

  const updatedEventDetails = React.useMemo(
    () => ({
      title: eventName,
      description: description,
      startDateTime: dateTimeInput,
      gameTitle: selectGame,
      gamerID: gamerID,
      device: device,
      eventImageUrl: fileContent,
    }),
    [
      eventName,
      description,
      dateTimeInput,
      selectGame,
      gamerID,
      device,
      fileContent,
    ]
  );

  return (
    <TouchableWithoutFeedback onPress={handleOutsideClick}>
      <View style={[styles.container, {}]}>
        <Header
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
          }}
          btnWalletTapped={() => { }}
          btnStartTutorialTapped={() => { }}
          btnMessageTapped={() => { }}
          btnNotificationTapped={() => { }}
          btnProfileTapped={() => { }}
        />
        <View style={[styles.mainView]}>
          <View style={{ alignSelf: "flex-start" }}>
            <Text
              style={[
                deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                  ? AppFontStyle.BOLD_ANYBODY_32
                  : AppFontStyle.BOLD_ANYBODY_20,
                {
                  color: AppColors.white,
                  alignSelf: "center",
                },
              ]}
            >
              {/* {(route.params.checkScreen || "Add") ===
              enumAddEditPublicPrivateScreen.Add
                ? "Create Event"
                : "Edit Event"} */}
              Update event
            </Text>
          </View>

          <View
            style={[
              styles.divider,
              {
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                    ? "100%"
                    : "80%",
              },
            ]}
          />

          <ScrollView showsVerticalScrollIndicator={false} ref={scrollViewRef}>
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                    ? "100%"
                    : "80%",
              }}
            >
              <View>
                <ChallengeModeComponent challengeMode={challengeMode} />
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { marginBottom: 12, marginTop: 24 },
                  ]}
                >
                  Event Details
                </Text>

                <View style={{ gap: 17 }}>
                  <EventNameAndGameComponent
                    eventName={eventName}
                    setEventName={setEventName}
                    games={games}
                    setSelectGame={setSelectGame}
                    normalizedSelectGame={normalizedSelectGame}
                  />
                  <Separator
                    color={AppColors.appGrayColor_1C1C1C}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />
                  <DeviceAndGameIdComponent
                    device={device}
                    setDevice={setDevice}
                    gamerID={gamerID}
                    setGamerID={setGamerID}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    scrollViewRef={scrollViewRef}
                  />
                  <DescriptionAndImageComponent
                    isOpen={isOpen}
                    description={description}
                    setDescription={setDescription}
                    setFileName={setFileName}
                    fileContent={fileContent}
                    setFileContent={setFileContent}
                    beltsTooltip={beltsTooltip}
                    type="update"
                    scrollViewRef={null}
                  />
                  <Separator
                    color={AppColors.appGrayColor_1C1C1C}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />
                  <SchedulingEventComponent
                    selectTime={selectTime}
                    setSelectTime={setSelectTime}
                    selectDate={selectDate}
                    setSelectDate={setSelectDate}
                    setShowDatePicker={setShowDatePicker}
                  />
                  <Separator
                    color={AppColors.appGrayColor_1C1C1C}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />

                  <SelectBeltsComponent
                    setStakeTokenAmount={setStakeTokenAmount}
                    setStakeCurrencyAmount={setStakeCurrencyAmount}
                    stakeCurrentPrize={stakeCurrentPrize}
                    setCornfirmPurchaseBeltModal={setCornfirmPurchaseBeltModal}
                    arrBeltMedalType={arrDetermineStakes}
                    setArrBeltMedalType={setArrDetermineStakes}
                    beltsTooltip={beltsTooltip}
                    setBeltsTooltip={setBeltsTooltip}
                    setBeltDetailTooltip={setBeltDetailTooltip}
                    type="update"
                    disableStakeEdit={actionStatus === true}
                  />

                  <Separator
                    color={AppColors.appGrayColor_1C1C1C}
                    height={2}
                    marginTop={0}
                    marginBottom={0}
                    marginHorizontal={0}
                  />
                  {/* {beltDetailTooltip && ( */}
                  <View
                    style={{
                      paddingVertical:
                        deviceSize === DEVICE_SIZES.XS ||
                          deviceSize === DEVICE_SIZES.SM
                          ? 10
                          : 20,
                      paddingHorizontal:
                        deviceSize === DEVICE_SIZES.XS ||
                          deviceSize === DEVICE_SIZES.SM
                          ? 10
                          : 20,
                      borderRadius: 10,
                      gap: 10,
                      backgroundColor: AppColors.purple_453B50,
                      flexDirection:
                        deviceSize === DEVICE_SIZES.XS ||
                          deviceSize === DEVICE_SIZES.SM
                          ? formattedBeltString === "0"
                            ? "row"
                            : "column"
                          : "row",
                      minWidth:
                        deviceSize === DEVICE_SIZES.XS ||
                          deviceSize === DEVICE_SIZES.SM
                          ? "100%"
                          : 450,
                      justifyContent: "space-between",
                      // alignItems: "center",
                      ...(deviceSize === DEVICE_SIZES.XS ||
                        deviceSize === DEVICE_SIZES.SM
                        ? {}
                        : {
                          position: "absolute",
                          bottom: -90,
                        }),
                    }}
                  >
                    <View
                      style={{
                        gap: 10,
                      }}
                    >
                      <Text style={AppFontStyle.MEDIUM_ANYBODY_14}>
                        You have selected : {formattedBeltString} belts
                      </Text>
                      <Text style={AppFontStyle.BOLD_ANYBODY_18}>
                        worth : {totalStakeTokenAmount} credit credit
                      </Text>
                    </View>
                    <View style={{ alignItems: "flex-start" }}>
                      <View
                        style={{
                          paddingVertical: 10,
                          paddingHorizontal: 20,
                          borderRadius: 10,
                          backgroundColor: AppColors.black,
                        }}
                      >
                        <Text style={AppFontStyle.BOLD_ANYBODY_22}>
                          {totalStakeCurrencyAmount.toFixed(2)}
                        </Text>
                      </View>
                    </View>
                  </View>
                  {/* )} */}
                </View>
              </View>
              <View
                style={{
                  justifyContent: "flex-end",
                  flexDirection: "row",
                  marginTop: 20,
                  gap: 10,
                  // height: 38,
                }}
              >
                <TouchableOpacity
                  style={{
                    borderRadius: 10,
                    marginBottom: 15,
                    justifyContent: "center",
                    alignItems: "center",
                    borderWidth: 2,
                    borderColor: AppColors.appViolentColor_6D08C3,
                    width: 146,
                  }}
                  onPress={() => {
                    navigation.dispatch(StackActions.pop());
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      {
                        paddingVertical: 12,
                        paddingHorizontal: 40,
                        color: AppColors.white,
                      },
                    ]}
                  >
                    Back
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={{
                    backgroundColor: AppColors.appViolentColor_6D08C3,
                    borderRadius: 10,
                    marginBottom: 15,
                    justifyContent: "center",
                    alignItems: "center",
                    width: 146,
                  }}
                  onPress={() => checkValidation()}
                  disabled={showLoader}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      {
                        paddingVertical: 8,
                        paddingHorizontal: 40,
                        color: AppColors.white,
                      },
                    ]}
                  >
                    {showLoader ? "Updating..." : "Update"}
                  </Text>
                </TouchableOpacity>

                <ChangesReadyToSendModal
                  showModal={showChangesReadyModal}
                  setShowModal={setShowChangesReadyModal}
                  eventID={route.params.eventID}
                  onClose={() => setShowChangesReadyModal(false)}
                  updatedEventDetails={updatedEventDetails}
                  previousEventDetails={previousEventDetails}
                  accessToken={accessToken}
                />
              </View>
            </View>
          </ScrollView>
        </View>
        {showYoutubePopup && (
          <StreamingAccountModal
            showPopup={showYoutubePopup}
            closePopup={closePopup}
            image={AppImages.icYoutubeStreaming}
            connected={false}
          />
        )}
        {showTwitchPopup && (
          <StreamingAccountModal
            showPopup={showTwitchPopup}
            closePopup={closePopup}
            image={AppImages.twitchStream}
            connected={true}
          />
        )}
        {connectedPopup && (
          <ConnetedPopup
            showPopup={connectedPopup}
            closePopup={() => setConnectedPopup(false)}
          />
        )}
        {showDatePicker && (
          <DateTimePickerModal
            showModal={showDatePicker}
            setShowModal={setShowDatePicker}
            selectedDate={(date) => {
              const formattedDate = dayjs(date).toISOString();
              setDateTimeInput(formattedDate);
              setSelectDate(dayjs(date).format("DD/MM/YYYY"));
              setSelectTime(dayjs(date).format("HH:mm"));
            }}
            selectDate={selectDate}
            selectTime={selectTime}
            timePicker={true}
          />
        )}
        {cornfirmPurchaseBeltModal && (
          <CornfirmPurchaseBeltModal
            setArrBeltMedalType={setArrDetermineStakes}
            arrBeltMedalType={arrDetermineStakes}
            accessToken={accessToken}
            showModal={cornfirmPurchaseBeltModal}
            userBalanceData={userBalanceData}
            setRefreshAPICall={setRefreshAPICall}
            setShowModal={setCornfirmPurchaseBeltModal}
            dataSelectedBelt={arrDetermineStakes.find(
              (item) => item.isSelected
            )}
            numberOfBelts={
              arrDetermineStakes.find((item) => item.isSelected).stakeBeltAmount
            }
            selectedBelt={(data) => {
              setBeltPurchaseSuccessModal(true);
              // setShowPaymentScreen(true);
            }}
            jumpToPurchaseToken={(isNavigate: false) => {
              if (isNavigate) {
                navigateToScreen(navigation, AppScreens.PurchaseScreen, {
                  screen: "event",
                  type: "public",
                });
              }
            }}
          />
        )}
        {competitorModel && (
          <CompetitorsModal
            showModal={competitorModel}
            setShowModal={setCompetitorModel}
            apiData={apiData}
            setApiData={setApiData}
            accessToken={accessToken}
            setRefreshAPICall={() => {
              setRefreshAPICall;
            }}
            isUpdate={true}
            eventID={route.params.eventData.eventID}
          />
        )}
        {balancePopup && (
          <NoBalancePopup
            showPopup={balancePopup}
            closePopup={() => setBalancePopup(false)}
          />
        )}{" "}
        {inefficientBeltsPopup && (
          <InefficientBeltsPopup
            showPopup={inefficientBeltsPopup}
            closePopup={() => setInefficientBeltsPopup(false)}
          />
        )}
        {beltPurchaseSuccessModal && (
          <BeltPurchaseSuccessModal
            arrBeltMedalType={arrDetermineStakes}
            showModal={beltPurchaseSuccessModal}
            setShowModal={setBeltPurchaseSuccessModal}
            numberOfBelts={
              arrDetermineStakes.find((item) => item.isSelected).stakeBeltAmount
            }
            dataBuyBelt={arrDetermineStakes.find((item) => item.isSelected)}
            backProfileTapped={() => {
              // reloadAPIs();
            }}
          />
        )}
        {showLoader && <ShowLoader showIndicater={showLoader} />}
      </View>
    </TouchableWithoutFeedback>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    deviceflexDirection: {
      flexDirection: "row",
    },
    viewStyle: {
      width: "30%",
    },
    container: {
      flex: 1,
      backgroundColor: AppColors.black_121212,
    },
    mainView: {
      flex: 1,
      padding: 20,
    },
    challegeMode: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    divider: {
      height: 2,
      marginTop: 16,
      marginBottom: 16,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: "100%",
    },
    headerTitle: {
      color: AppColors.white,
      paddingTop: 16,
    },

    inputWrapper: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      paddingHorizontal: 12,
      borderRadius: 10,
    },
    textInputStyle: {
      paddingVertical: 18,
      paddingHorizontal: 10,
      color: AppColors.white,
      outlineStyle: "none",
    },
    buyBeltButtonStyle: {
      paddingVertical: 14,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 10,
      shadowOpacity: 0,
      width: 132,
      flex: 1,
    },
    leftWrapper: {
      flex: 0.5,
      flexDirection: "column",
      gap: 12,
    },

    rightDurationWrapper: {
      width: "20%",
      flexDirection: "column",
      gap: 12,
    },
    gameWrapper: {
      width: "40%",
      flexDirection: "column",
      gap: 12,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },

      inputWrapper: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        flex: 0.5,

        flexDirection: "column",
        gap: 12,
      },

      rightDurationWrapper: {
        width: "20%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        width: "40%",
        flexDirection: "column",
        gap: 12,
      },

      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
        marginBottom: 20,
      },
      viewStyle: {
        width: "47%",
      },
    },
    [DEVICE_SIZES.MD]: {
      viewStyle: {
        width: "47%",
      },

      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },

      inputWrapper: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },

      rightDurationWrapper: {
        width: "20%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },

      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
        marginBottom: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      viewStyle: {
        width: "47%",
      },

      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },

      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        flex: 1,

        flexDirection: "column",
        gap: 12,
      },

      rightDurationWrapper: {
        width: "20%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        width: "40%",
        flexDirection: "column",
        gap: 12,
      },

      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
        marginBottom: 20,
      },
      mainView: { padding: 10 },
    },

    [DEVICE_SIZES.XS]: {
      viewStyle: {
        width: "47%",
      },

      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
        marginBottom: 20,
      },

      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },

      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        flex: 1,

        flexDirection: "column",
        gap: 12,
      },

      rightDurationWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      mainView: { padding: 10 },
    },
  }
);
